import { render, staticRenderFns } from "./MarketingForm.vue?vue&type=template&id=36187d2d"
import script from "./MarketingForm.vue?vue&type=script&lang=js"
export * from "./MarketingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports